import * as types from './mutation-types'
import { ROUTE_NAME } from 'enums/routes'

const PAGE_SEO_MODEL = {
  MetaTitle: '',
  MetaDescription: '',
  Directives: '',
  Keyphrases: []
}

const ERROR_PAGE_SEO = {
  MetaTitle: 'Page Not Found | Finance Magnates',
  MetaDescription:
    'Page not found. Head to Finance Magnates Intelligence to discover the latest reports.',
  Directives: '',
  Keyphrases: []
}

const PAGE_SEO_QIR = {
  MetaTitle: 'Finance Magnates Intelligence Reports',
  MetaDescription:
    'Access trading volumes, key trends, regional insights, regulatory updates, and intelligence reports for the FX/CFD brokerage industry.',
  Directives: '',
  Keyphrases: []
}

const PAGE_SEO_COMPLIANCE = {
  MetaTitle: 'Regulatory Intelligence Insights - Your Monthly Compliance Guide',
  MetaDescription:
    'Stay updated with essential compliance insights and trends in regulatory intelligence every month.',
  Directives: '',
  Keyphrases: []
}

const PAGE_SEO_BY_ROUTE_NAME = {
  [ROUTE_NAME.HOMEPAGE]: PAGE_SEO_QIR,
  [ROUTE_NAME.QIR]: PAGE_SEO_QIR,
  [ROUTE_NAME.QIR_THANK_YOU]: PAGE_SEO_QIR,
  [ROUTE_NAME.COMPLIANCE_REPORT]: PAGE_SEO_COMPLIANCE,
  [ROUTE_NAME.COMPLIANCE_REPORT_THANK_YOU]: PAGE_SEO_COMPLIANCE
}

export const state = () => ({
  pageSeo: { ...PAGE_SEO_MODEL },
  ogSiteName: ''
})

export const getters = {
  pageSeo: state => state.pageSeo,
  ogSiteName: state => state.ogSiteName
}

export const actions = {
  /**
   * TODO connect to BE here if requested
   */
  async requestPageSeo({ commit }, { routeName }) {
    const seoData = PAGE_SEO_BY_ROUTE_NAME[routeName] || ERROR_PAGE_SEO
    commit(types.SET_PAGE_SEO, seoData)
  }
}

export const mutations = {
  [types.SET_PAGE_SEO](state, seo) {
    state.pageSeo = seo || {}
  }
}
